module.exports = __webpack_public_path__ + "static/media/SampleContract.07eebe66.pdf";